export default "__VITE_ASSET__C7UIG6j2__"